import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import styles from '../styles/BlogSection.module.css';

const BlogSection = ({ eyebrow, title, posts, moreLabel, moreTo }) => {
  const { language } = useI18n();

  return (
    <section className={styles.section} aria-labelledby="blog-section-title">
      <div className={styles.head}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h2 id="blog-section-title">{title}</h2>
      </div>

      <div className={styles.grid}>
        {posts.map(post => {
          const postTo = post.toByLanguage && post.toByLanguage[language]
            ? post.toByLanguage[language]
            : post.to;

          return (
            <article className={styles.card} key={post.id}>
              <Link className={styles.imageLink} to={postTo}>
                <img
                  className={styles.image}
                  src={post.image}
                  alt={post.imageAlt}
                  loading="lazy"
                  decoding="async"
                />
              </Link>
              <div className={styles.body}>
                <span className={styles.category}>{post.category}</span>
                <h3><Link to={postTo}>{post.title}</Link></h3>
                <Link className={styles.read} to={postTo}>{post.readLabel}</Link>
              </div>
            </article>
          );
        })}
      </div>

      <Link className={styles.more} to={moreTo}>{moreLabel}</Link>
    </section>
  );
};

BlogSection.defaultProps = {
  eyebrow: 'Our journal',
  title: 'Stories from Grain Bites',
  posts: [],
  moreLabel: 'View more stories',
  moreTo: '/Sourdough',
};

export default BlogSection;
